import React from 'react';
import { Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import colors from '../../../assets/theme/colors';
import CareDocumentDetailSheet from '../../../features/careSourceProcessing/CareDocumentDetailSheet';
import {
  fetchTrackerSourceRecord,
} from '../../../features/tracking';
import TherapyPrepSourceEntrySheet from '../../Reports/TherapyPrepSourceEntrySheet';
import LogFormShell from '../../UI/LogFormShell';

const TrackerSourceSheet = ({
  open = false,
  source = null,
  onClose = () => {},
}) => {
  const theme = useTheme();
  const [record, setRecord] = React.useState(null);
  const [linkedSource, setLinkedSource] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    let active = true;

    if (!open || !source?.id) {
      setRecord(null);
      setLinkedSource(null);
      setError('');
      setLoading(false);
      return () => {
        active = false;
      };
    }

    setLoading(true);
    setError('');
    fetchTrackerSourceRecord(source)
      .then(async (nextRecord) => {
        if (!active) return;
        setRecord(nextRecord);
        setError(nextRecord ? '' : "We couldn't find that source.");
        const linkedSourceId = nextRecord?.sourceNoteId || nextRecord?.metadata?.sourceNoteId || '';
        if (source.type === 'timelineEntry' && linkedSourceId) {
          const nextLinkedSource = await fetchTrackerSourceRecord({ type: 'careSource', id: linkedSourceId });
          if (active) setLinkedSource(nextLinkedSource);
        } else {
          setLinkedSource(null);
        }
      })
      .catch((sourceError) => {
        if (active) {
          setError(sourceError?.message || "We couldn't load that source.");
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [open, source]);

  if (source?.type === 'careSource' && record) {
    return (
      <CareDocumentDetailSheet
        open={open}
        source={record}
        onClose={onClose}
      />
    );
  }

  if (source?.type === 'timelineEntry' && record) {
    return (
      <TherapyPrepSourceEntrySheet
        open={open}
        entry={record}
        originalSource={linkedSource}
        onClose={onClose}
        accent={{
          primary: colors.semantic.sageDeep,
          ink: colors.semantic.sageInk || colors.semantic.sageDeep,
        }}
        theme={theme}
      />
    );
  }

  return (
    <LogFormShell
      open={open}
      onClose={onClose}
      title="Source"
      subtitle="Tracker source"
      forceDrawer
      maxWidth="sm"
    >
      {loading ? (
        <Alert severity="info" sx={{ borderRadius: '14px' }}>
          Loading source...
        </Alert>
      ) : (
        <Alert severity={error ? 'warning' : 'info'} sx={{ borderRadius: '14px' }}>
          {error || 'This tracker source is not available here yet.'}
        </Alert>
      )}
    </LogFormShell>
  );
};

export default TrackerSourceSheet;
